import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

const ProspectSequenceListTableSkeleton: React.FC = () => (
  <div className="prospect-sequence-list-table-skeleton">
    <div className="add-sequence-container-skeleton">
      <div className="add-sequence-header">
        <SkeletonLoading width={16} height={16} className='sequence-table-list-skeleton' />
        <SkeletonLoading width={69} height={14} className='sequence-table-list-skeleton' />
      </div>
    </div>
    {Array.from({ length: 3 }).map(() => (
      <div className="sequence-table-list">
      <div className="sequence-table-list-header">
        <div className="sequence-table-list-header-left">
          <SkeletonLoading width={16} height={16} className='sequence-table-list-skeleton' />
          <SkeletonLoading width={139} height={14} className='sequence-table-list-skeleton' />
        </div>
        <div className="sequence-table-list-header-right">
          <SkeletonLoading width={67} height={14} className='sequence-table-list-skeleton' />
          <SkeletonLoading width={24} height={24} className='sequence-table-list-skeleton' circle />
        </div>
      </div>
      <div className="sequence-table-list-row">
        <div className="sequence-table-list-row-left">
          <SkeletonLoading width={24} height={24} className='sequence-table-list-skeleton' circle />
          <SkeletonLoading width={81} height={20} className='sequence-table-list-skeleton' />
        </div>
        <SkeletonLoading width={139} height={14} className='sequence-table-list-skeleton' />
      </div>
    </div>
    ))}
  </div>
);

export default ProspectSequenceListTableSkeleton;
